import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import './axios'
import {BootstrapVue,TablePlugin,BootstrapVueIcons,IconsPlugin} from "bootstrap-vue"
require('@/assets/scss/app.css')
Vue.config.productionTip = false
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'

Vue.use(BootstrapVue)
Vue.use(TablePlugin)
Vue.use(BootstrapVueIcons)
Vue.use(IconsPlugin)

new Vue({
  router:router,
  render: h => h(App),
}).$mount('#app')

export const EventBus = new Vue();




